<script setup lang="ts">
type BannerColor = "primary" | "secondary" | "error" | "success" | "warning";

const props = withDefaults(
  defineProps<{
    title: string;
    description?: string;
    closable?: boolean;
    sticky?: boolean;
    color?: BannerColor;
  }>(),
  {
    description: undefined,
    closable: false,
    sticky: false,
    color: "error",
  }
);

const emit = defineEmits<{ close: [] }>();

const colorClasses: Record<BannerColor, string> = {
  primary: "bg-primary-100 text-primary-700",
  secondary: "bg-secondary-100 text-secondary-700",
  error: "bg-red-100 text-red-700",
  success: "bg-green-100 text-green-700",
  warning: "bg-gray-100 text-gray-700",
};
</script>

<template>
  <div role="status" aria-live="polite" class="py-6" :class="[colorClasses[props.color], sticky && 'sticky top-(--ui-header-height) z-10']">
    <UContainer class="flex items-start gap-4">
      <div class="flex flex-col gap-1 grow min-w-0">
        <p class="text-base leading-tight font-semibold">{{ title }}</p>
        <p v-if="description" class="text-sm">{{ description }}</p>
      </div>
      <button
        v-if="closable"
        type="button"
        :aria-label="$t('ui.close')"
        data-testid="app-banner-close"
        class="cursor-pointer rounded p-3 -mt-3 -mr-3 flex items-center justify-center text-current hover:bg-current/10"
        @click="emit('close')"
        square
      >
        <UIcon name="icon:close" class="size-4" aria-hidden="true" />
      </button>
    </UContainer>
  </div>
</template>
